export default __webpack_public_path__ + "static/media/0038.9a598aa4.png";